// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 11) return "static/js/17897358b735e9ae2c25.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"19":"c774106a5856dcebb3f7","139":"364604b5fc47e1565073","140":"32e1218307374901b45c"}[chunkId] + ".chunk.js";
};